var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.296 3.778A.778.778 0 0112.074 3h4.148a.778.778 0 01.778.778v4.148a.778.778 0 11-1.556 0V5.655l-3.51 3.512a.778.778 0 11-1.1-1.099l3.511-3.512h-2.271a.778.778 0 01-.778-.778zm-2.128 7.055a.778.778 0 010 1.099l-3.513 3.512h2.271a.778.778 0 010 1.556H3.778A.778.778 0 013 16.222v-4.148a.778.778 0 011.556 0v2.271l3.511-3.513a.778.778 0 011.1 0z"
  })));
}
export default SvgFullScreenIcon;